export default __webpack_public_path__ + "c1837686e03692948385c6ca986674df.svg";